
export enum NotificationTab {
  All = 'all',
  Unread = 'unread'
}

export type AppNotification = {
  id: number;
  sub_category_name: string;
  category_name: string;
  created_on: string;
  is_read: boolean;
  priority: number;
  summary_vars: Record<string, string>;
  description_vars: Record<string, string>;
};

export type NotificationsPopoverProps = {
  className?: string;
};

export type NotificationsPanelProps = {
  notifications: AppNotification[];
  activeTab: NotificationTab;
  onTabChange: (tab: NotificationTab) => void;
  onClose?: () => void;
  onMarkAllAsRead?: () => void;
  onDismissAll?: () => void;
  onDismiss?: (id: number) => void;
  onMarkReadStatus?: (id: number, isRead: boolean) => void;
  onLoadMore?: () => void;
  hasMore?: boolean;
  isLoading?: boolean;
  totalCount?: number;
  unreadCount?: number;
};

export type NotificationRowProps = {
  notification: AppNotification;
  onDismiss?: (id: number) => void;
  onMarkReadStatus?: (id: number, isRead: boolean) => void;
};
